import { render } from "./TargetDartIcon.vue?vue&type=template&id=03339a8b"
import script from "./TargetDartIcon.vue?vue&type=script&lang=js"
export * from "./TargetDartIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__